import { useMutation, useQueryClient } from "@tanstack/react-query";

import { moveMessages, type MoveMessagesResponse } from "~/entities/chat";
import { chatJobsKey, chatMessagesKey } from "~/entities/chat/useActiveChat";
import { chatListKey } from "~/entities/chat/useChats";

interface MoveMessagesVars {
    sourceChatId: string;
    // Workspace источника — для инвалидации правильного списка чатов (новый
    // чат мог появиться) и chats-registry.
    workspaceId: string;
    messageIds: string[];
    // Цель: существующий чат ИЛИ новый (не оба сразу).
    targetChatId?: string;
    newChatTitle?: string;
    // Удалить исходный чат, если он опустел после переноса.
    deleteSourceIfEmpty?: boolean;
}

// После переноса инвалидируем оба чата: у источника сообщения ушли,
// у цели — приехали (сообщения + job-снимки). generated-artifacts by-chat читаются
// по chat_uuid, поэтому тоже сбрасываем. Список чатов/registry — новый чат мог
// быть создан по newChatTitle.
export function useMoveMessages() {
    const qc = useQueryClient();
    return useMutation<MoveMessagesResponse, Error, MoveMessagesVars>({
        mutationFn: ({ sourceChatId, messageIds, targetChatId, newChatTitle, deleteSourceIfEmpty }) =>
            moveMessages(sourceChatId, { messageIds, targetChatId, newChatTitle, deleteSourceIfEmpty }),
        onSuccess: (res, vars) => {
            for (const chatId of [vars.sourceChatId, res.targetChatId]) {
                void qc.invalidateQueries({ queryKey: chatMessagesKey(chatId) });
                void qc.invalidateQueries({ queryKey: chatJobsKey(chatId) });
                void qc.invalidateQueries({ queryKey: ["v2", "chat", chatId, "generated-artifacts"] });
            }
            void qc.invalidateQueries({ queryKey: chatListKey(vars.workspaceId) });
            void qc.invalidateQueries({ queryKey: ["v2", "chats", "registry"] });
        },
    });
}
